var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodesRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2807 3.89841C13.2169 5.57257 14.685 6.40964 15.1777 7.5025C15.6074 8.45573 15.6074 9.54427 15.1777 10.4975C14.685 11.5904 13.2169 12.4274 10.2807 14.1016C7.3445 15.7757 5.8764 16.6128 4.67171 16.4878C3.62093 16.3787 2.66636 15.8344 2.04533 14.9903C1.33333 14.0225 1.33333 12.3483 1.33333 9C1.33333 5.65169 1.33333 3.97753 2.04533 3.00973C2.66636 2.16557 3.62093 1.62129 4.67171 1.51222C5.8764 1.38718 7.3445 2.22426 10.2807 3.89841Z",
    stroke: "#6651BD",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodesRun);
export default __webpack_public_path__ + "static/media/nodes-run.25a72ff2b1d767425d6a94937ca6f1f0.svg";
export { ForwardRef as ReactComponent };